export default __webpack_public_path__ + "static/media/daniel-testi.b1f161da.jpg";